import { render } from "./AssignResourceGroupForm.vue?vue&type=template&id=8ac7bb6e&ts=true"
import script from "./AssignResourceGroupForm.vue?vue&type=script&lang=ts"
export * from "./AssignResourceGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__